//This file was autogenerated by autoreq with the following parameters:
//___________
//fileName   : *.ts
//basePath   : .
//output     : app/models/requireme.ts
//exports     : true
//inputs     : app/models
export * from 'app/models/articulo';
export * from 'app/models/banco';
export * from 'app/models/bitacorarad';
export * from 'app/models/caja';
export * from 'app/models/cajaruta';
export * from 'app/models/camion';
export * from 'app/models/camioncajasconectadas';
export * from 'app/models/camionEAD';
export * from 'app/models/cancelacionentregaingresoausuario';
export * from 'app/models/cancelacionfactura';
export * from 'app/models/cancelacionguia';
export * from 'app/models/cancelacionrep';
export * from 'app/models/cancelaciontimbrado';
export * from 'app/models/cancelaciontimbradorep';
export * from 'app/models/cargadescarga';
export * from 'app/models/cargasEAD';
export * from 'app/models/cargaze';
export * from 'app/models/choferEAD';
export * from 'app/models/choferruta';
export * from 'app/models/choferze';
export * from 'app/models/ciudad';
export * from 'app/models/cliente';
export * from 'app/models/clientedescripcionpaquete';
export * from 'app/models/clientedireccion';
export * from 'app/models/cobrador';
export * from 'app/models/cobranza';
export * from 'app/models/colonia';
export * from 'app/models/conceptofactura';
export * from 'app/models/configsistema';
export * from 'app/models/consultasze';
export * from 'app/models/contabilidad';
export * from 'app/models/contenidos';
export * from 'app/models/correocontactodatos';
export * from 'app/models/cortediario';
export * from 'app/models/corteingresosze';
export * from 'app/models/corteturno';
export * from 'app/models/corteventa';
export * from 'app/models/cotizador';
export * from 'app/models/datoscomercial';
export * from 'app/models/depositobanco';
export * from 'app/models/descargaze';
export * from 'app/models/descripcioncontenidopaquete';
export * from 'app/models/descripcionpaquete';
export * from 'app/models/direccion';
export * from 'app/models/documentacion';
export * from 'app/models/enrutamiento';
export * from 'app/models/entregadomiciliorealizada';
export * from 'app/models/entregaingresosausuario';
export * from 'app/models/entregaocurre';
export * from 'app/models/entregazerealizada';
export * from 'app/models/estado';
export * from 'app/models/factura';
export * from 'app/models/facturaguias';
export * from 'app/models/facturaguiasguia';
export * from 'app/models/facturaNotadecredito';
export * from 'app/models/fichadepositobanco';
export * from 'app/models/filtroantiguedadsaldos';
export * from 'app/models/filtroguia';
export * from 'app/models/filtrostatuscajaruta';
export * from 'app/models/filtrostatuscamion';
export * from 'app/models/firmausuario';
export * from 'app/models/firmausuarioremota';
export * from 'app/models/guia';
export * from 'app/models/identificacion';
export * from 'app/models/informacioncomercial';
export * from 'app/models/itemcatalogosat';
export * from 'app/models/liberacionentregaze';
export * from 'app/models/manifiestoRAD';
export * from 'app/models/matrizdistancias';
export * from 'app/models/matriztarifa';
export * from 'app/models/matriztarifarangoespecial';
export * from 'app/models/matriztiempos';
export * from 'app/models/movimientocaja';
export * from 'app/models/movimientocajaview';
export * from 'app/models/municipio';
export * from 'app/models/notadecredito';
export * from 'app/models/notificacionze';
export * from 'app/models/nuevoclientedocumentacion';
export * from 'app/models/ocurre';
export * from 'app/models/pago';
export * from 'app/models/pagofactura';
export * from 'app/models/pagorealizado';
export * from 'app/models/paquetepp';
export * from 'app/models/parametrosconteoguia';
export * from 'app/models/partidaaclaracion';
export * from 'app/models/rastreo';
export * from 'app/models/recolecciondomicilio';
export * from 'app/models/rep';
export * from 'app/models/repguiasdoc';
export * from 'app/models/reportecobranzasemanal';
export * from 'app/models/reportecomportamientocomercial';
export * from 'app/models/reportediarioventa';
export * from 'app/models/reporteeficienciaead';
export * from 'app/models/reporteenviocanalcomercializacion';
export * from 'app/models/reporteestadisticasclientes';
export * from 'app/models/reporteguiasenviadasrecibidas';
export * from 'app/models/reportelibroadministracion';
export * from 'app/models/reportepartidasaclaracion';
export * from 'app/models/reporteseguimientoventas';
export * from 'app/models/repsaldocartera';
export * from 'app/models/requerimientoacuse';
//Ignored app/models/requireme because its file name matches with the output file
export * from 'app/models/residenciafiscalcliente';
export * from 'app/models/rol';
export * from 'app/models/rolmap';
export * from 'app/models/ruta';
export * from 'app/models/rutaEAD';
export * from 'app/models/saldosusuarioszeview';
export * from 'app/models/segmento';
export * from 'app/models/servicio';
export * from 'app/models/session';
export * from 'app/models/status';
export * from 'app/models/statuscajaruta';
export * from 'app/models/sucursal';
export * from 'app/models/tarifa';
export * from 'app/models/tarifapagochofer';
export * from 'app/models/tarifapp';
export * from 'app/models/timbradofactura';
export * from 'app/models/timbradorep';
export * from 'app/models/tipocolonia';
export * from 'app/models/turno';
export * from 'app/models/ubicaciones';
export * from 'app/models/unidadsat';
export * from 'app/models/usuario';
export * from 'app/models/usuarioapi';
export * from 'app/models/usuarioze';
export * from 'app/models/vehiculoze';
export * from 'app/models/vendedor';
export * from 'app/models/viajeapp';
export * from 'app/models/viajecobranza';
export * from 'app/models/viajeEAD';
export * from 'app/models/viajes';
export * from 'app/models/viajeZe';
export * from 'app/models/viajezeapp';
export * from 'app/models/zonaextendida';



// WEBPACK FOOTER //
// ./app/models/requireme.ts